/*
 * Validate agaist expression on form data
 */
$.formUtils.addValidator({
	name : 'expr',
	validatorFunction : function(val, $el, config, language, $form) {
		var isValid = true;
		var actualValue = $el.val(); // needed because validator framework trims the 'value': 'COLORE ' becomes 'COLORE'
		var formObject = $form.data('inputData');
		var expression = $el.data('validationExprFormula');
		if(expression != undefined){
			isValid = $.evaluate(expression, window, [formObject], ['formObject']);
		} else {
			var formInstance = $form.data('formInstance');
			if(formInstance && formInstance.settings.reference){
				var exprFn = $.functionCase($el.data('name') + '-expr-validator-formula');
				var fn = formInstance.settings.reference[exprFn];
				if(typeof fn == 'function'){
					// wrap response to be a promise, so that can be managed server side validations too
					var promise = $.when(fn.call(formInstance.settings.reference, formObject, formInstance));
					return promise.then(response => {
						if($.isPlainObject(response)){
							isValid = response.isValid;
							if(!isValid){
								this.errorMessage = response.msg;
							}
						} else {
							isValid = response;
						}
						return isValid;
					});
				} else {
					console.log(`Please, add one of \n\t- "data-validatione-expr-formula" attribute of the field element, with a valid boolean expression, \n\t- "${exprFn}(formData, formInstance) {}," function as validator function for "${formInstance.settings.reference._FULL_}". It must return a boolean or an object like "{isValid:<boolean>, msg: <string>}" or a promise (resolved with boolean or object)`);
				}
			}
		}
		return isValid;
	},
	errorMessage : '',
	errorMessageKey: ''
});
